import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import { useNavigate } from "react-router-dom";

const LoyaltyInvite = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: 10,
        px: 3,
        textAlign: "center",
        backgroundColor: "#FFF2EF",
        borderRadius: 4,
        mx: 2,
      }}>
      <Stack spacing={2} alignItems="center">
        <LoyaltyIcon sx={{ fontSize: 50, color: "#FD7762" }} />
        <Typography variant="h4" fontWeight="bold">
          Join the CakeyHand Family
        </Typography>
        <Typography variant="body1" maxWidth="sm">
          Our loyalty program rewards you for shopping <strong>in-store</strong>{" "}
          — because we love seeing you in person. Create an account, and enroll
          to start earning points every time you visit!
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#FD7762", borderRadius: 2 }}
          onClick={() => navigate("/signup?loyalty=1")}>
          Sign Up
        </Button>
      </Stack>
    </Box>
  );
};

export default LoyaltyInvite;
